export const PIN_DEFAULT_LENGTH = 6;

export enum PinState {
  viewed = 'viewed',
  redirected_to_reset = 'redirected_to_reset'
}

export const RESET_PIN_FORM_FIELDS = {
  firstPin: 'first_pin',
  secondPin: 'second_pin'
};
